/* 
 * Export component file to be used on project
*/

import LineSeparator from './LineSeparator.js';
export default LineSeparator;
